var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Serializer } from '@airgap/beacon-core';
import { ExtensionMessageTarget, NetworkType } from '@airgap/beacon-types';
import { windowRef } from '@airgap/beacon-core';
import { getTzip10Link } from '../../utils/get-tzip10-link';
import { isAndroid, isIOS } from '../../utils/platform';
import { PostMessageTransport } from '@airgap/beacon-transport-postmessage';
import { desktopList, extensionList, iOSList, webList } from './wallet-lists';
/**
 * Initialize with tezos wallets for backwards compatibility
 */
let localDesktopList = desktopList;
let localExtensionList = extensionList;
let localWebList = webList;
let localiOSList = iOSList;
export const getDesktopList = () => {
    return localDesktopList;
};
export const setDesktopList = (desktopList) => {
    localDesktopList = desktopList;
};
export const getExtensionList = () => {
    return localExtensionList;
};
export const setExtensionList = (extensionList) => {
    localExtensionList = extensionList;
};
export const getWebList = () => {
    return localWebList;
};
export const setWebList = (webList) => {
    localWebList = webList;
};
export const getiOSList = () => {
    return localiOSList;
};
export const setiOSList = (iosList) => {
    localiOSList = iosList;
};
const serializer = new Serializer();
const defaultExtensions = [
    'ookjlbkiijinhpmnjffcofjonbfbgaoc',
    'gpfndedineagiepkpinficbcbbgjoenn' // Spire
];
export var Platform;
(function (Platform) {
    Platform[Platform["DESKTOP"] = 0] = "DESKTOP";
    Platform[Platform["IOS"] = 1] = "IOS";
    Platform[Platform["ANDROID"] = 2] = "ANDROID";
})(Platform || (Platform = {}));
export var WalletType;
(function (WalletType) {
    WalletType["IOS"] = "ios";
    WalletType["ANDROID"] = "android";
    WalletType["EXTENSION"] = "extension";
    WalletType["DESKTOP"] = "desktop";
    WalletType["WEB"] = "web";
})(WalletType || (WalletType = {}));
/**
 * @internalapi
 *
 */
export class Pairing {
    static getPlatfrom() {
        return __awaiter(this, void 0, void 0, function* () {
            return isAndroid(window) ? Platform.ANDROID : isIOS(window) ? Platform.IOS : Platform.DESKTOP;
        });
    }
    static getPairingInfo(pairingPayload, statusUpdateHandler, mobileWalletHandler, platform) {
        return __awaiter(this, void 0, void 0, function* () {
            const activePlatform = platform !== null && platform !== void 0 ? platform : (yield Pairing.getPlatfrom());
            const pairingCode = pairingPayload.p2pSyncCode;
            const postmessageSyncCode = pairingPayload.postmessageSyncCode;
            const preferredNetwork = pairingPayload.preferredNetwork;
            switch (activePlatform) {
                case Platform.DESKTOP:
                    return Pairing.getDesktopPairingAlert(pairingCode, statusUpdateHandler, postmessageSyncCode, mobileWalletHandler, preferredNetwork);
                case Platform.IOS:
                    return Pairing.getIOSPairingAlert(pairingCode, statusUpdateHandler, preferredNetwork);
                case Platform.ANDROID:
                    return Pairing.getAndroidPairingAlert(pairingCode, statusUpdateHandler, preferredNetwork);
                default:
                    throw new Error('platform unknown');
            }
        });
    }
    static getDesktopPairingAlert(pairingCode, statusUpdateHandler, postmessageSyncCode, mobileWalletHandler, network) {
        return __awaiter(this, void 0, void 0, function* () {
            const availableExtensions = yield PostMessageTransport.getAvailableExtensions();
            availableExtensions.forEach((ext) => {
                const index = defaultExtensions.indexOf(ext.id);
                if (index >= 0) {
                    defaultExtensions.splice(index, 1);
                }
            });
            const walletLists = [];
            if (getExtensionList().length > 0) {
                walletLists.push({
                    title: 'Browser Extensions',
                    type: WalletType.EXTENSION,
                    wallets: [
                        ...availableExtensions.map((app) => {
                            var _a, _b, _c, _d, _e;
                            const ext = getExtensionList().find((extEl) => extEl.id === app.id);
                            return {
                                key: (_a = ext === null || ext === void 0 ? void 0 : ext.key) !== null && _a !== void 0 ? _a : app.id,
                                name: (_b = app.name) !== null && _b !== void 0 ? _b : ext === null || ext === void 0 ? void 0 : ext.name,
                                logo: (_c = app.iconUrl) !== null && _c !== void 0 ? _c : ext === null || ext === void 0 ? void 0 : ext.logo,
                                shortName: (_d = app.shortName) !== null && _d !== void 0 ? _d : ext === null || ext === void 0 ? void 0 : ext.shortName,
                                color: (_e = app.color) !== null && _e !== void 0 ? _e : ext === null || ext === void 0 ? void 0 : ext.color,
                                enabled: true,
                                clicked: false,
                                clickHandler() {
                                    return __awaiter(this, void 0, void 0, function* () {
                                        if (this.clicked) {
                                            return;
                                        }
                                        this.clicked = true;
                                        if (postmessageSyncCode) {
                                            const postmessageCode = yield serializer.serialize(yield postmessageSyncCode());
                                            const message = {
                                                target: ExtensionMessageTarget.EXTENSION,
                                                payload: postmessageCode,
                                                targetId: app.id
                                            };
                                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                            windowRef.postMessage(message, windowRef.location.origin);
                                        }
                                        statusUpdateHandler(WalletType.EXTENSION, this);
                                    });
                                }
                            };
                        }),
                        ...getExtensionList()
                            .filter((app) => defaultExtensions.some((extId) => extId === app.id))
                            .map((app) => ({
                            key: app.key,
                            name: app.name,
                            shortName: app.shortName,
                            color: app.color,
                            logo: app.logo,
                            enabled: false,
                            clickHandler: () => {
                                // Don't do anything
                            }
                        }))
                    ].sort((a, b) => a.key.localeCompare(b.key))
                });
            }
            if (getDesktopList().length > 0) {
                walletLists.push({
                    title: 'Desktop & Web Wallets',
                    type: WalletType.DESKTOP,
                    wallets: [
                        ...getDesktopList().map((app) => ({
                            key: app.key,
                            name: app.name,
                            shortName: app.shortName,
                            color: app.color,
                            logo: app.logo,
                            enabled: true,
                            clicked: false,
                            clickHandler() {
                                return __awaiter(this, void 0, void 0, function* () {
                                    if (this.clicked) {
                                        return;
                                    }
                                    this.clicked = true;
                                    const code = yield serializer.serialize(yield pairingCode());
                                    const link = getTzip10Link(app.deepLink, code);
                                    window.open(link, '_blank');
                                    statusUpdateHandler(WalletType.DESKTOP, this, true);
                                });
                            }
                        })),
                        ...(yield Pairing.getWebList(pairingCode, statusUpdateHandler, network))
                    ].sort((a, b) => a.key.localeCompare(b.key))
                });
            }
            if (getiOSList().length > 0) {
                walletLists.push({
                    title: 'Mobile Wallets',
                    type: WalletType.IOS,
                    wallets: [
                        ...getiOSList().map((app) => ({
                            key: app.key,
                            name: app.name,
                            shortName: app.shortName,
                            color: app.color,
                            logo: app.logo,
                            enabled: true,
                            clicked: false,
                            clickHandler() {
                                return __awaiter(this, void 0, void 0, function* () {
                                    if (this.clicked) {
                                        return;
                                    }
                                    this.clicked = true;
                                    const code = yield serializer.serialize(yield pairingCode());
                                    mobileWalletHandler(code);
                                    statusUpdateHandler(WalletType.IOS, this, true);
                                });
                            }
                        }))
                    ].sort((a, b) => a.key.localeCompare(b.key))
                });
            }
            return {
                walletLists,
                buttons: []
            };
        });
    }
    static getIOSPairingAlert(pairingCode, statusUpdateHandler, network) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                walletLists: [
                    {
                        title: 'Mobile Wallets',
                        type: WalletType.IOS,
                        wallets: getiOSList()
                            .map((app) => ({
                            key: app.key,
                            name: app.name,
                            shortName: app.shortName,
                            color: app.color,
                            logo: app.logo,
                            enabled: true,
                            clicked: false,
                            clickHandler() {
                                var _a;
                                return __awaiter(this, void 0, void 0, function* () {
                                    if (this.clicked) {
                                        return;
                                    }
                                    this.clicked = true;
                                    const code = yield serializer.serialize(yield pairingCode());
                                    const link = getTzip10Link((_a = app.deepLink) !== null && _a !== void 0 ? _a : app.universalLink, code);
                                    // iOS does not trigger deeplinks with `window.open(...)`. The only way is using a normal link. So we have to work around that.
                                    const a = document.createElement('a');
                                    a.setAttribute('href', link);
                                    a.dispatchEvent(new MouseEvent('click', { view: window, bubbles: true, cancelable: true }));
                                    statusUpdateHandler(WalletType.IOS, this, true);
                                });
                            }
                        }))
                            .sort((a, b) => a.key.localeCompare(b.key))
                    },
                    {
                        title: 'Web Wallets',
                        type: WalletType.WEB,
                        wallets: [...(yield Pairing.getWebList(pairingCode, statusUpdateHandler, network))].sort((a, b) => a.key.localeCompare(b.key))
                    }
                ],
                buttons: []
            };
        });
    }
    static getAndroidPairingAlert(pairingCode, statusUpdateHandler, network) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                walletLists: [
                    {
                        title: 'Web Wallets',
                        type: WalletType.WEB,
                        wallets: [...(yield Pairing.getWebList(pairingCode, statusUpdateHandler, network))].sort((a, b) => a.key.localeCompare(b.key))
                    }
                ],
                buttons: [
                    {
                        title: 'Mobile Wallets',
                        text: 'Connect Wallet',
                        clickHandler: () => __awaiter(this, void 0, void 0, function* () {
                            const code = yield serializer.serialize(yield pairingCode());
                            const qrLink = getTzip10Link('tezos://', code);
                            window.open(qrLink, '_blank');
                            statusUpdateHandler(WalletType.ANDROID);
                        })
                    }
                ]
            };
        });
    }
    static getWebList(pairingCode, statusUpdateHandler, network) {
        return __awaiter(this, void 0, void 0, function* () {
            return getWebList()
                .map((app) => ({
                key: app.key,
                name: app.name,
                shortName: app.shortName,
                color: app.color,
                logo: app.logo,
                enabled: true,
                clicked: false,
                clickHandler() {
                    if (this.clicked) {
                        return;
                    }
                    this.clicked = true;
                    const newTab = window.open('', '_blank');
                    pairingCode()
                        .then((code) => serializer.serialize(code))
                        .then((code) => {
                        var _a;
                        const link = getTzip10Link((_a = app.links[network]) !== null && _a !== void 0 ? _a : app.links[NetworkType.MAINNET], code);
                        if (newTab) {
                            newTab.location.href = link;
                        }
                        else {
                            window.open(link, '_blank');
                        }
                        statusUpdateHandler(WalletType.WEB, this, true);
                    })
                        .catch((error) => {
                        // eslint-disable-next-line no-console
                        console.error(error);
                    });
                }
            }))
                .sort((a, b) => a.key.localeCompare(b.key));
        });
    }
}
//# sourceMappingURL=Pairing.js.map